import { render, staticRenderFns } from "./ImgUpload.vue?vue&type=template&id=0a198f12&scoped=true"
import script from "./ImgUpload.vue?vue&type=script&lang=js"
export * from "./ImgUpload.vue?vue&type=script&lang=js"
import style0 from "./ImgUpload.vue?vue&type=style&index=0&id=0a198f12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a198f12",
  null
  
)

export default component.exports